// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"631":"f48ed6cf","723":"b52cb119","787":"fa3c4679","968":"ce24a6ca"}[chunkId] + ".chunk.js";
};